import { DocumentsState, InitialDocumentState } from '../state/documents.state';
import { DocumentsAction, DocumentsActions } from '../actions/documents.action';

export function DocumentsReducers(
  state = InitialDocumentState,
  action: DocumentsAction
): DocumentsState {
  switch (action.type) {
    case DocumentsActions.GetAllDocumentsSuccess: {
      return {
        ...state,
        getAllDocumentsSuccess: action.payload,
        getAllDocumentsError: null,
      };
    }
    case DocumentsActions.GetAllDocumentsError: {
      return {
        ...state,
        getAllDocumentsError: action.payload,
        getAllDocumentsSuccess: null,
      };
    }
    case DocumentsActions.AddDocuments: {
      return {
        ...state,
        addDocumentInProgress: true,
      };
    }
    case DocumentsActions.GetAddDocumentsSuccess: {
      return {
        ...state,
        getAddDocumentsSuccess: action.payload,
        getAddDocumentsError: null,
        addDocumentInProgress: false,
      };
    }
    case DocumentsActions.GetAddDocumentsError: {
      return {
        ...state,
        getAddDocumentsError: action.payload,
        getAddDocumentsSuccess: null,
        addDocumentInProgress: false,
      };
    }
    case DocumentsActions.ResetAddDocuments: {
      return {
        ...state,
        getAddDocumentsSuccess: null,
        getAddDocumentsError: null,
      };
    }
    case DocumentsActions.ResetEditDocument: {
      return {
        ...state,
        getEditDocumentsSuccess: null,
        getEditDocumentsError: null,
      };
    }
    case DocumentsActions.GetEditDocumentsSuccess: {
      return {
        ...state,
        getEditDocumentsSuccess: action.payload,
        getEditDocumentsError: null,
        editDocumentsInProgress: false,
      };
    }
    case DocumentsActions.GetEditDocumentsError: {
      return {
        ...state,
        getEditDocumentsError: action.payload,
        getEditDocumentsSuccess: null,
        editDocumentsInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentsTypeSuccess: {
      return {
        ...state,
        getDocumentsTypeSuccess: action.payload,
        getDocumentsTypeError: null,
        getDocumentTypeInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentsTypeError: {
      return {
        ...state,
        getDocumentsTypeError: action.payload,
        getDocumentsTypeSuccess: null,
        getDocumentTypeInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentsTypeReset: {
      return {
        ...state,
        getDocumentsTypeError: null,
        getDocumentsTypeSuccess: null,
        getDocumentTypeInProgress: false,
      };
    }
    case DocumentsActions.AddDocumentsTypeSuccess: {
      return {
        ...state,
        addDocumentsTypeSuccess: action.payload,
        addDocumentsTypeError: null,
      };
    }
    case DocumentsActions.AddDocumentsTypeError: {
      return {
        ...state,
        addDocumentsTypeError: action.payload,
        addDocumentsTypeSuccess: null,
      };
    }
    case DocumentsActions.GetTypeRecordSuccess: {
      return {
        ...state,
        getTypeRecordSuccess: action.payload,
        getTypeRecordError: null,
      };
    }
    case DocumentsActions.GetTypeRecordError: {
      return {
        ...state,
        getTypeRecordError: action.payload,
        getTypeRecordSuccess: null,
      };
    }
    case DocumentsActions.GetDocumentsByIdSuccess: {
      return {
        ...state,
        getDocumentsByIdSuccess: action.payload,
        getDocumentsByIdError: null,
        getDocumentsIdInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentsByIdError: {
      return {
        ...state,
        getDocumentsByIdError: action.payload,
        getDocumentsByIdSuccess: null,
        getDocumentsIdInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentsByIdReset: {
      return {
        ...state,
        getDocumentsByIdError: null,
        getDocumentsByIdSuccess: null,
        getDocumentsIdInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentCountSuccess: {
      return {
        ...state,
        getDocumentCountSuccess: action.payload,
        getDocumentCountError: null,
      };
    }
    case DocumentsActions.GetDocumentCountError: {
      return {
        ...state,
        getDocumentCountError: action.payload,
        getDocumentCountSuccess: null,
      };
    }
    case DocumentsActions.GetDocumentSearchSuccess: {
      return {
        ...state,
        getDocumentSearchSuccess: action.payload,
        getDocumentsSearchError: null,
      };
    }
    case DocumentsActions.GetDocumentSearchError: {
      return {
        ...state,
        getDocumentsSearchError: action.payload,
        getDocumentSearchSuccess: null,
      };
    }
    case DocumentsActions.DownloadDocumentFileSuccess: {
      return {
        ...state,
        downloadDocumentFileSuccess: action.payload,
        downloadDocumentFileError: null,
      };
    }
    case DocumentsActions.DownloadDocumentFileError: {
      return {
        ...state,
        downloadDocumentFileError: action.payload,
        downloadDocumentFileSuccess: null,
      };
    }
    case DocumentsActions.GetDocumentsNameSuccess: {
      return {
        ...state,
        getDocumentsNameSuccess: action.payload,
        getDocumentsNameError: null,
      };
    }
    case DocumentsActions.GetDocumentsNameError: {
      return {
        ...state,
        getDocumentsNameError: action.payload,
        getDocumentsNameSuccess: null,
      };
    }
    case DocumentsActions.AddDocumentsNameSuccess: {
      return {
        ...state,
        addDocumentsNameSuccess: action.payload,
        addDocumentsNameError: null,
      };
    }
    case DocumentsActions.AddDocumentsNameError: {
      return {
        ...state,
        addDocumentsNameError: action.payload,
        addDocumentsNameSuccess: null,
      };
    }
    case DocumentsActions.GetDocumentImportSuccess: {
      return {
        ...state,
        getDocumentImportSuccess: action.payload,
        getDocumentImportError: null,
      };
    }
    case DocumentsActions.GetDocumentImportError: {
      return {
        ...state,
        getDocumentImportError: action.payload,
        getDocumentImportSuccess: null,
      };
    }
    case DocumentsActions.UploadDocumentsSuccess: {
      return {
        ...state,
        uploadDocumentsSuccess: action.payload,
        uploadDocumentsError: null,
      };
    }
    case DocumentsActions.UploadDocumentsError: {
      return {
        ...state,
        uploadDocumentsError: action.payload,
        uploadDocumentsSuccess: null,
      };
    }
    case DocumentsActions.ResetUploadedDocuments: {
      return {
        ...state,
        uploadDocumentsError: null,
        uploadDocumentsSuccess: null,
      };
    }
    case DocumentsActions.RemoveDocumentSuccess: {
      return {
        ...state,
        removeDocumentSuccess: action.payload,
        removeDocumentError: null,
      };
    }
    case DocumentsActions.RemoveDocumentError: {
      return {
        ...state,
        getDocumentImportError: action.payload,
        getDocumentImportSuccess: null,
      };
    }
    case DocumentsActions.GetAllRecordsError: {
      return {
        ...state,
        allRecords: [],
        allRecordsError: action.payload,
        allRecordsInProgress: false,
      };
    }
    case DocumentsActions.GetAllRecordsReset: {
      return {
        ...state,
        allRecords: [],
        allRecordsError: null,
        allRecordsInProgress: false,
      };
    }
    case DocumentsActions.GetAllRecordsSuccess: {
      return {
        ...state,
        allRecords: action.payload,
        allRecordsError: null,
        allRecordsInProgress: false,
      };
    }
    case DocumentsActions.GetAllRecords: {
      return {
        ...state,
        allRecordsInProgress: true,
      };
    }
    case DocumentsActions.DocumentsType: {
      return {
        ...state,
        getDocumentTypeInProgress: true,
      };
    }
    case DocumentsActions.GetDocumentsById: {
      return {
        ...state,
        getDocumentsIdInProgress: true,
      };
    }
    case DocumentsActions.EditDocuments: {
      return {
        ...state,
        editDocumentsInProgress: true,
      };
    }
    case DocumentsActions.GetDocumentContentById: {
      return {
        ...state,
        getDocumentContentByIdInProgress: true,
      };
    }
    case DocumentsActions.GetDocumentContentByIdSuccess: {
      return {
        ...state,
        getDocumentContentByIdSuccess: action.payload,
        getDocumentContentByIdError: null,
        getDocumentContentByIdInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentContentByIdError: {
      return {
        ...state,
        getDocumentContentByIdError: action.payload,
        getDocumentContentByIdSuccess: null,
        getDocumentContentByIdInProgress: false,
      };
    }
    case DocumentsActions.GetDocumentContentByIdReset: {
      return {
        ...state,
        getDocumentContentByIdError: null,
        getDocumentContentByIdSuccess: null,
        getDocumentContentByIdInProgress: false,
      };
    }
    case DocumentsActions.AcknowledgeDocumentSuccess: {
      return {
        ...state,
        acknowledgeDocument: true
      }
    }
    case DocumentsActions.AcknowledgeDocumentReset: {
      return {
        ...state,
        acknowledgeDocument: false
      }
    }
    default: {
      return state;
    }
  }
}
